import { Component } from '@angular/core';
import { environment } from 'environments/environment';
import { CaptureAdminCaptureInvoiceLineItemReportsComponent } from '../../../capture-admin/pages/capture-admin-capture-invoice-line-item-reports/capture-admin-capture-invoice-line-item-reports.component';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';
import { NewReportOptionsTemplateDirective } from '../../../shared/directives/new-report-options-template.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportMonthRangeOptionComponent } from '../../../shared/components/report-month-range-option/report-month-range-option.component';
import { ReportDetailsTemplateDirective } from '../../../shared/directives/report-details-template.directive';
import { ReportAppliedMonthRangeOptionComponent } from '../../../shared/components/report-applied-month-range-option/report-applied-month-range-option.component';

@Component({
    templateUrl: '../../../capture-admin/pages/capture-admin-capture-invoice-line-item-reports/capture-admin-capture-invoice-line-item-reports.component.html',
    imports: [ReportsComponent,
              NewReportOptionsTemplateDirective,
              FormsModule,
              ReactiveFormsModule,
              ReportMonthRangeOptionComponent,
              ReportDetailsTemplateDirective,
              ReportAppliedMonthRangeOptionComponent]
})
export class ClientPortalCaptureInvoiceLineItemReportComponent extends
    CaptureAdminCaptureInvoiceLineItemReportsComponent {
  reportsUrl = `${environment.captureApi.url}/client_capture_invoice_line_item_reports`;
  reportsCountUrl = `${environment.captureApi.url}/client_capture_invoice_line_item_reports/count`;
}
